import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Specification } from '@dgx-pr-spa/shared/util';
import { deepCopy } from './../../../core/helpers/deep-copy';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent implements OnInit {
  @Input() specifications: Specification[][] = [];
  @Input() rowHasSpecDifferences: boolean[] = [];
  @Input() hideSpecDifferenceRows: boolean;
  @Input() visibleRows: number = null;

  sizeAndConNames = ['Height', 'Width', 'Depth', 'Construction'];

  ngOnInit(): void {
    this.specifications = deepCopy(this.specifications).map((spec) => {
      return spec.map((s) => {
        if (s.name === 'Height (mm)') {
          s.name = 'Height';
        }
        if (s.name === 'Width (mm)') {
          s.name = 'Width';
        }
        if (s.name === 'Depth (mm)') {
          s.name = 'Depth';
        }
        return s;
      });
    });
  }

  hasWhiteSpace(val: string) {
    const str = val?.slice(0, 200);
    return str?.includes(' ');
  }

  getSpecByName(specifications: Specification[], name: string) {
    return specifications?.find((spec) => spec.name === name);
  }

  getSpecsWithoutSizeAndConNames(specifications: Specification[]) {
    return specifications
      ?.filter((x) => !this.sizeAndConNames.includes(x.name))
      .map((x) => x.name);
  }

  getIsDifferences(name: string) {
    let difference = false;
    this.specifications.forEach((spec) => {
      if (spec.find((s) => s.name === name)?.highlight) {
        difference = true;
      }
    });
    return difference;
  }
}
